import { Stack, Typography } from "@mui/material";
import BackPageButton from "components/buttons/BackPageButton";
import { BackPageButtonSearchParamName } from "components/buttons/BackPageButton/types";
import { DATE_TIME_FORMAT } from "constants/dateFormats";
import ROUTES from "constants/routes";
import dayjs from "dayjs";
import withCollapse from "hocs/withCollapse";
import qs from "qs";
import { Dispatch, SetStateAction } from "react";
import { Link } from "react-router-dom";
import palette from "theme/palette";
import { CompetencyMapWithProgressInfo } from "../ProgressInfo/types";
import HeaderCard from "./components/HeaderCard";

const CollapsedHeaderCard = withCollapse(HeaderCard);

interface IHeaderProps {
  disabled: boolean;
  isCreate: boolean;
  isEditable: boolean;
  competencyMapWithProgressInfo: CompetencyMapWithProgressInfo | undefined;
  setIsEditable: Dispatch<SetStateAction<boolean>>;
  setIsHeaderExpanded?: (isExpanded: boolean) => void;
}

const Header = ({
  competencyMapWithProgressInfo,
  disabled,
  isCreate,
  isEditable,
  setIsEditable,
  setIsHeaderExpanded,
}: IHeaderProps) => {
  const originalCompetencyMap = competencyMapWithProgressInfo?.originalCompetencyMap;

  return (
    <Stack>
      <Stack
        justifyContent='space-between'
        direction='row'
        alignItems='center'>
        <BackPageButton
          defaultValue={{
            text: "Список карт компетенций",
            link: `/${ROUTES.COMPETENCE_MAPS}`,
          }}
        />
        <Stack
          spacing={1}
          alignItems='flex-end'>
          <Typography color={palette.base[200]}>
            созд. {dayjs(competencyMapWithProgressInfo?.createdAt).format(DATE_TIME_FORMAT)}
          </Typography>
          {originalCompetencyMap && (
            <Typography color={palette.base[200]}>
              Является дубликатом карты{" "}
              <Link
                to={{
                  pathname: `/${ROUTES.COMPETENCE_MAPS}/view/${originalCompetencyMap.id}`,
                  search: qs.stringify({
                    [BackPageButtonSearchParamName.COMPETENCY_MAP_ID]: competencyMapWithProgressInfo.id,
                  }),
                }}>
                {originalCompetencyMap.title || ""}
              </Link>
            </Typography>
          )}
        </Stack>
      </Stack>
      <CollapsedHeaderCard
        disabled={disabled}
        isCreate={isCreate}
        isEditable={isEditable}
        setIsEditable={setIsEditable}
        competencyMapWithProgressInfo={competencyMapWithProgressInfo}
        onlyIconButtonMode
        collapseButtonProps={{ disabled: isEditable }}
        triggerIsExpanded={(isExpanded, setIsExpanded) => isEditable && !isExpanded && setIsExpanded(true)}
        triggerIsExpandedSignal={isEditable}
        onExpandedAnimationEnd={setIsHeaderExpanded}
      />
    </Stack>
  );
};

export default Header;
